<span class="icon">
    @if (message.icon && message.icon.name) {
        <span class="scoreboard-sport-icon" [ngClass]="color">
            <vn-icon name="{{ message.icon!.name }}" size="12" />
        </span>
    }
</span>
@if (message.time) {
    <span class="time">{{ message.time }}</span>
}
<span msTextAutoScroll class="text" [allowEventPropagation]="true">{{ message.text }}</span>
